import { render, staticRenderFns } from "./SquareCard.vue?vue&type=template&id=349e2968&scoped=true"
import script from "./SquareCard.vue?vue&type=script&lang=js"
export * from "./SquareCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349e2968",
  null
  
)

export default component.exports